
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftRight75 as ObiThreewayAcuatorPistonInleftRight75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-right-75.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftRight75 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-right-75',
   elementClass: ObiThreewayAcuatorPistonInleftRight75Element,
   events: {
     
   }
  });
 
 